export default __webpack_public_path__ + "static/media/checkmark_filter.e09d2d57.png";